<template>
    <div>
        <div v-if="!isInitialized">Loading order selector</div>
        <div class="resource-selector row" v-if="isInitialized">
            <div class="col">
                <input type="hidden" :name="formFieldName" :value="selectedFormValue">
                <multiselect :options="options"
                             @search-change="asyncQuery"
                             @select="select"
                             :internal-search="false"
                             v-model="selectedOrder"
                             :placeholder="placeholder"
                             :loading="isLoading"
                             :preserve-search="true">
                    <template slot="singleLabel" slot-scope="{ option }">
                        <div class="row">
                            <div class="col">
                                <span>{{ option.order_number }}</span>
                            </div>
                        </div>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                        <div class="row">
                            <div class="col">
                                <span>{{ option.order_number }}</span>
                            </div>
                        </div>
                    </template>
                    <template slot="noResult">
                        No results found
                    </template>
                    <template slot="noOptions">
                        Start searching by typing
                    </template>
                    <pre class="language-json"><code>{{ selectedOrder }}</code></pre>
                </multiselect>
                <div v-if="couldNotFindPreselectedOrder" class="text text-danger">The prefilled order with id
                    ({{ prefilledOrderId }}) was not found.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _ from "lodash";
import axios from "axios";
import qs from "qs";

export default {
    components: {Multiselect},
    name: "OrderSearch",

    props: {
        placeholder: {
            default: 'Add by searching...'
        },
        formFieldName: {
            default: 'order_uuid'
        },
        showCancelledOnly: {
            default: false
        },
        prefilledOrderId:{
            default: null
        }
    },

    mounted() {
        if (this.prefilledOrderId !== null && this.prefilledOrderId !== '') {
            this.fetchAndSelectSingleOrder(this.prefilledOrderId).finally(() => {
                this.isInitialized = true;
            })
        } else {
            this.isInitialized = true;
        }
    },

    data: () => {
        return {
            query: {},
            options: [],
            selectedOrder: null,
            isLoading: false,
            isInitialized: false,
        };
    },

    computed: {
        selectedFormValue() {
            return this.selectedOrder?.uuid;
        },

        couldNotFindPreselectedOrder() {
            return !this.isLoading && this.prefilledOrderId !== null && this.prefilledOrderId !== '' && this.selectedOrder === null;
        }
    },

    methods: {

        asyncQuery(queryString) {
            if (!queryString) {
                this.options = [];
                return;
            }

            this.isLoading = true;
            this.fetchOrders(queryString);
        },

        fetchOrders: _.debounce(function (queryString) {
            let query = {
                filters: {
                    query: queryString,
                }
            };

            if (this.showCancelledOnly) {
                query.filters.derived_status = 'cancelled';
            }

            const stringifiedQueryString = qs.stringify(query);

            axios.get(`/admin/api/orders?${stringifiedQueryString}`)
                    .then((resp) => {
                        this.isLoading = false;
                        this.options = resp.data.data;
                    })
                    .catch(() => {
                        this.isLoading = false
                    });
        }, 500),

        fetchAndSelectSingleOrder(id) {
            return axios.get(`/admin/api/orders/${id}`)
                    .then(resp => {
                        this.select(resp.data.data);
                    })
        },

        select(resource) {
            this.selectedOrder = resource;
            this.$emit('order-selected', this.selectedOrder.uuid);
        },

        remove() {
            this.selectedOrder = null;
        }
    }
}
</script>

<style scoped>
</style>
